import React, { useCallback, useMemo } from "react";
import { FaRegFolder, FaRegFolderOpen } from "react-icons/fa";
import { devModeConfig } from "../../components/DevMode.helpers";
import { MdAddCircle } from "react-icons/md";
import { VscCloseAll } from "react-icons/vsc";

export const NodeRendererFolder = ({
  element,
  isExpanded,
  getNodeProps,
  level,
  onAddNodeClick,
  onCloseAll,
  handleExpand
}) => {

  const isOpenFiles = element?.id === devModeConfig.ids.OPEN_TABS;

  const type = useMemo(()=>{
    if(level !== 2) return;
    if(element.name === devModeConfig.primitiva.explorerCaption){
      return devModeConfig.primitiva.type;
    }
    else if(element.name === devModeConfig.operacion.explorerCaption){
      return devModeConfig.operacion.type;
    }
    else if(element.name === devModeConfig.template.explorerCaption){
      return devModeConfig.template.type;
    }
  }, [level, element?.name]);

  const handleAddClick = useCallback((event) => {
    if(isExpanded){
      event.preventDefault();
      event.stopPropagation();
    }
    onAddNodeClick && onAddNodeClick(element, type)
  }, [isExpanded, type, onAddNodeClick]);

  const handleCloseAllClick = useCallback((event) => {
    if(!isExpanded){
      event.preventDefault();
      event.stopPropagation();
    }
    onCloseAll && onCloseAll(element)
  }, [isExpanded, onCloseAll]);

  const fontColor = useMemo(()=>{
    if(level === 3){
      return devModeConfig[element.metadata.type].fontColor;
    }
    if(type && devModeConfig[type].fontColor){
      return devModeConfig[type].fontColor;
    }
    return "inherit";
  }, [type, element]);

  return  (
    <div {...getNodeProps()} onClick={handleExpand} style={{paddingLeft: 10 * (level - 1), textWrap: "nowrap", display: "flex", alignItems: "center" }}>
      <FolderIcon isOpen={isExpanded} />
      <div style={{flex: 1, color: fontColor}}>{element.name}</div>
      {isExpanded && type && 
        <MdAddCircle onClick={handleAddClick} style={{marginLeft: 4, width: 18, minWidth: 18, height: 18, cursor: "pointer"}} />
      }
      {isExpanded && isOpenFiles && 
        <VscCloseAll onClick={handleCloseAllClick} style={{marginLeft: 4, width: 18, minWidth: 18, height: 18, cursor: "pointer"}} />
      }
    </div>
  )  
}

const FolderIcon = ({ isOpen }) =>
  isOpen ? (
    <FaRegFolderOpen color="#f7d367" className="icon" style={{width: 18, minWidth: 18, height: 18}}/>
  ) : (
    <FaRegFolder color="#f7d367" className="icon" style={{width: 18, minWidth: 18, height: 18}}/>
  );
